// Pure formatters shared by the proposals page, its drawers and cards.
// Extracted verbatim from RentFlowsIndex.vue so the rendered copy stays identical.

export const formNumber = value => {
  const normalized = String(value || '')
    .replace(/\./g, '')
    .replace(',', '.')
    .replace(/[^\d.]/g, '');
  const number = Number(normalized);
  return Number.isFinite(number) ? number : 0;
};

export const formatFormBRL = value =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const formatBRL = value =>
  value == null || value === ''
    ? '—'
    : new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        maximumFractionDigits: 0,
      }).format(Number(value));

export const numericValue = value => {
  if (value == null || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const valuesAreEquivalent = (firstValue, secondValue) => {
  const first = numericValue(firstValue);
  const second = numericValue(secondValue);
  if (first === null || second === null) return false;

  return Math.abs(first - second) < 1;
};

export const formatDate = value => {
  if (!value) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(value));
};

export const parseDeadlineDate = value => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const daysUntilDeadline = value => {
  const deadline = parseDeadlineDate(value);
  if (!deadline) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  deadline.setHours(0, 0, 0, 0);
  return Math.round((deadline.getTime() - today.getTime()) / 86400000);
};

export const formatDeadlineDate = value => {
  const deadline = parseDeadlineDate(value);
  if (!deadline) return formatDate(value);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(deadline);
};

export const daysSinceDate = value => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return Math.max(0, Math.floor((today.getTime() - date.getTime()) / 86400000));
};

export const activityDurationLabel = offer => {
  const days = daysSinceDate(offer?.submitted_at || offer?.created_at);
  if (days == null) return '';
  if (days === 0) return 'Enviada hoje';
  if (days === 1) return '1 dia em atividade';
  return `${days} dias em atividade`;
};

export const clientInitials = name => {
  const normalized = String(name || '').trim();
  if (!normalized) return '?';

  return normalized
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase();
};

export const residentsSituationFromValues = (residentsCount, hasPets) => {
  const count = Number(residentsCount || 0);
  if (!count) return '';

  const residents =
    count >= 6
      ? '6 ou mais moradores'
      : `${count} ${count === 1 ? 'morador' : 'moradores'}`;

  return `${residents}${hasPets ? ' com animal de estimação' : ''}`;
};
